"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => ({
  notifyItem: {
    width: theme.notify.width,
    borderStyle: 'solid',
    borderWidth: theme.notify.borderWidth,
    borderRadius: theme.notify.borderRadius,
    boxShadow: theme.notify.boxShadow,
    margin: '12px 0',
    backgroundColor: theme.notify.bgColor,
    boxSizing: 'border-box'
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '7px 12px 6px 12px'
  },
  title: {
    flex: '1 1 auto',
    position: 'relative',
    top: -1,
    color: theme.notify.textColor
  },
  icon: {
    flex: '0 0 auto',
    marginRight: 12
  },
  closeIcon: {
    flex: '0 0 auto',
    alignSelf: 'flex-start',
    marginTop: 5,
    marginLeft: 12,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  descriptionContainer: {
    borderStyle: 'solid',
    borderWidth: 0,
    borderTopWidth: theme.notify.borderWidth,
    padding: '8px 12px'
  },
  description: {
    color: theme.notify.textColor
  },
  normal: {
    borderColor: theme.notify.normalBorderColor,
    '& $titleContainer': {
      backgroundColor: theme.notify.normalTitleBgColor
    },
    '& $descriptionContainer': {
      borderColor: theme.notify.normalBorderColor
    },
    '& $closeIcon, & $icon': {
      color: theme.notify.normalIconColor
    }
  },
  success: {
    borderColor: theme.notify.successBorderColor,
    '& $titleContainer': {
      backgroundColor: theme.notify.successTitleBgColor
    },
    '& $descriptionContainer': {
      borderColor: theme.notify.successBorderColor
    },
    '& $closeIcon, & $icon': {
      color: theme.notify.successIconColor
    }
  },
  error: {
    borderColor: theme.notify.errorBorderColor,
    '& $titleContainer': {
      backgroundColor: theme.notify.errorTitleBgColor
    },
    '& $descriptionContainer': {
      borderColor: theme.notify.errorBorderColor
    },
    '& $closeIcon, & $icon': {
      color: theme.notify.errorIconColor
    }
  }
});

exports.default = _default;